import { createContext, useContext } from "react";
import { useActiveProfile } from "@/domain/hooks";
import type { Profile } from "@/domain/types";

const ProfileContext = createContext<Profile | null>(null);

/**
 * Surfaces the active profile (backed by the zustand store + localStorage)
 * via context for components that prefer it. The store remains the source of
 * truth; this is a thin convenience wrapper.
 */
export function ProfileProvider({ children }: { children: React.ReactNode }) {
  const profile = useActiveProfile();
  return <ProfileContext.Provider value={profile}>{children}</ProfileContext.Provider>;
}

export function useProfile(): Profile {
  const ctx = useContext(ProfileContext);
  if (!ctx) throw new Error("useProfile must be used within ProfileProvider");
  return ctx;
}
